<template>
  <div class="box">
    <div class="box-top">
      <img :src="user.head_img" v-if="user.head_img" class="box-top-tx">
      <img v-else class="box-top-tx" src="../../../static/img2/tx.png" alt="">
    </div>
    <div class="box-buttom">
      <div class="box-buttom-hed">
        <div :class="hedind==1?'box-buttom-hed-title':'box-buttom-hed-titlefalse'" @click="hedind=1">
          个人信息
        </div>
        <div :class="hedind==2?'box-buttom-hed-title':'box-buttom-hed-titlefalse'" @click="hedind=2">
          我的收藏
        </div>
        <div :class="hedind==3?'box-buttom-hed-title':'box-buttom-hed-titlefalse'" @click="hedind=3">
          修改密码
        </div>
      </div>
      <div class="box-buttom-input" v-if="hedind==1">
        <div class="box-buttom-input-li">
          <div class="box-buttom-input-left">
            <img src="../../../static/img2/dain.png" alt="">
            <span>姓名</span>
          </div>
          <div class="box-buttom-input-rigth">
            <el-input type="text" v-model="user.realname" placeholder="姓名" class="xusao"></el-input>
          </div>
        </div>
        <div class="box-buttom-input-li">
          <div class="box-buttom-input-left">
            <img src="../../../static/img2/dain.png" alt="">
            <span>学校</span>
          </div>
          <div class="box-buttom-input-rigth">
            <div class="box-buttom-input-rigthtit">
              {{user.school_name||'学校'}}
            </div>
          </div>
        </div>
        <div class="box-buttom-input-li">
          <div class="box-buttom-input-left">
            <img src="../../../static/img2/dain.png" alt="">
            <span>院系</span>
          </div>
          <div class="box-buttom-input-rigth">
            <div class="box-buttom-input-rigthtit">
              {{user.depart_name||'院系'}}
            </div>
          </div>
        </div>
        <div class="box-buttom-input-li">
          <div class="box-buttom-input-left">
            <img src="../../../static/img2/dain.png" alt="">
            <span>专业</span>
          </div>
          <div class="box-buttom-input-rigth">
            <div class="box-buttom-input-rigthtit">
              {{user.major_name||'专业'}}
            </div>
          </div>
        </div>
        <div class="box-buttom-input-li">
          <div class="box-buttom-input-left">
            <img src="../../../static/img2/dain.png" alt="">
            <span>年级</span>
          </div>
          <div class="box-buttom-input-rigth">
            <div class="box-buttom-input-rigthtit">
              {{user.grade_name||'年级'}}
            </div>
          </div>
        </div>
        <div class="box-buttom-input-li">
          <div class="box-buttom-input-left">
            <img src="../../../static/img2/dain.png" alt="">
            <span>班级</span>
          </div>
          <div class="box-buttom-input-rigth">
            <div class="box-buttom-input-rigthtit">
              {{user.class_name||'班级'}}
            </div>
          </div>
        </div>
        <!-- <div class="box-buttom-input-li">
          <div class="box-buttom-input-left">
            <img src="../../../static/img2/dain.png" alt="">
            <span>生日</span>
          </div>
          <div class="box-buttom-input-rigth">
            <el-input type="text" v-model="user.birthday" placeholder="生日" class="xusao"></el-input>
          </div>
        </div> -->
        <div class="box-buttom-input-li">
          <div class="box-buttom-input-left">
            <img src="../../../static/img2/dain.png" alt="">
            <span>秘钥</span>
          </div>
          <div class="box-buttom-input-rigth">
            <el-input type="text" v-model="user.classKey" placeholder="秘钥" class="xusao"></el-input>
          </div>
        </div>
        <div class="box-buttom-input-li" style="display: flex;justify-content: center;padding-bottom: .4rem;">
          <!-- <el-button type="primary" size="large" @click="submitFormuser()"></el-button> -->
          <div style="width: 1rem;height: .5rem;background-color: #409EFF;text-align: center;
          line-height: .5rem;color: #fff;font-size: .18rem;cursor: pointer;border-radius: .05rem;" @click="submitFormuser()">
            确 定
          </div>
        </div>
      </div>
      <div class="box-tabs" v-if="hedind==2">
        <div class="box-tabs-ul" v-if="totle>0">
          <div class="box-tabs-li" v-for="item in courseList" :key="item.id" @click="courseHandler(item.learn_id,item)">
            <div style="position: relative;width: 3.4rem;height: 2rem;">
              <img class="box-tabs-li-img" :src="imgurl+item.learn.thum" alt="">
              <div style="position: absolute;bottom: 0rem;background: rgba(0, 0, 0, 0.8);width: 3.4rem;height: .3rem;display: flex;justify-content: center;align-items: center;" class="textoverflow">
                <span style="color: #fff;font-size: .14rem;" class="textoverflow">{{ item.learn.name }}</span>
              </div>
            </div>
            <div class="box-tabs-li-but-tit">
              <div>
                <img src="../../../static/img2/time.png" alt="" style="width: .12rem;height: .13rem;">
                <span style="margin-left: .08rem;">{{ item.learn.change_time }}</span>
              </div>
              <div style="margin-right: .2rem;margin-left: .1rem;">
                <img src="../../../static/img2/rs.png" alt="" style="width: .12rem;height: .13rem;">
                <span style="margin-left: .08rem;">{{ computeCount(item.learn.user_count) }}</span>
              </div>
              <div style="display: flex;justify-content: space-between;width: .8rem;">
                <img v-for="iten in 5" :key="iten" src="../../../static/img2/xx.png" alt="" style="width: .14rem;height: .13rem;">
              </div>
            </div>
          </div>
        </div>
        <div class="box-tabs-ul" v-else>
          <div style="width: 100%;min-height: 5.4rem;;display: flex;justify-content: center;align-items: center;">
            <div style="display: flex;flex-direction: column;align-items: center;">
              <el-icon :size="30" color="#409EFC">
                <FolderOpened />
              </el-icon>
              <span class="box-tabs-ulicontit" style="">
                暂无数据
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="box-buttom-input" v-if="hedind==3">
        <div class="box-buttom-input-li">
          <div class="box-buttom-input-left" style="width: 1.6rem;">
            <img src="../../../static/img2/dain.png" alt="">
            <span>原 密 码</span>
          </div>
          <div class="box-buttom-input-rigth">
            <el-input type="password" show-password v-model="ruleForm.old_password" placeholder="原密码" class="xusao"></el-input>
          </div>
        </div>
        <div class="box-buttom-input-li">
          <div class="box-buttom-input-left" style="width: 1.6rem;">
            <img src="../../../static/img2/dain.png" alt="">
            <span>新 密 码</span>
          </div>
          <div class="box-buttom-input-rigth">
            <el-input type="password" show-password v-model="ruleForm.new_password" placeholder="新密码" class="xusao"></el-input>
          </div>
        </div>
        <div class="box-buttom-input-li">
          <div class="box-buttom-input-left" style="width: 1.6rem;">
            <img src="../../../static/img2/dain.png" alt="">
            <span>确认新密码</span>
          </div>
          <div class="box-buttom-input-rigth">
            <el-input type="password" show-password v-model="ruleForm.new_password_repeat" placeholder="确认新密码" class="xusao"></el-input>
          </div>
        </div>
        <div class="box-buttom-input-li" style="display: flex;justify-content: center;padding-bottom: .4rem;">
          <div style="width: 1rem;height: .5rem;background-color: #409EFF;text-align: center;line-height: .5rem;color: #fff;font-size: .18rem;cursor: pointer;border-radius: .05rem;" @click="submitFormpassword()">
            确认修改
          </div>
          <!-- <el-button type="primary" size="large" @click="submitFormpassword()">确认修改</el-button> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MyInfo',
  inject: ['reload'],
  data() {
    return {
      hedind: 1,
      user: {},
      ruleForm: {},
      totle: 0,
      courseList: [],
      imgurl: 'http://www.univrlab.com/'
    }
  },
  methods: {
    // 修改密码
    submitFormpassword() {
      if (this.ruleForm.new_password_repeat == this.ruleForm.new_password) {
        this.$http.updatePassword(this.ruleForm).then((res) => {
          if (res.code !== 0) {
            this.$message.success('修改密码成功！')
            this.$http.userLoginOut().then((res) => {
              this.$cookies.remove('token')
              this.$store.dispatch('SetUserInfo', null)
              this.$router.go(0)
              this.$router.push({ name: 'Login' })
            })
          } else {
            this.$message.error(res.message)
          }
        })
      }else{
        this.$message.error('两次密码不一致！')
      }
    },
    // 修改用户信息
    submitFormuser() {
      this.$http.updateUserInfo(this.user).then((res) => {
        if (res.code !== 0) {
          this.$store.commit('SetUserInfo', this.user)
          this.$message.success(res.message)
          this.getUserInfo()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 点击了详情
    courseHandler(courseId) {
      // console.log(courseId)
      this.$router.push({
        path: `/courses/${courseId}/details-introduce`,
      })
    },
    // 获取用户收藏列表
    getfavorList() {
      this.$http.favoritesList().then((res) => {
        console.log(res)
        if (res.code == 200) {
          this.courseList = res.data.data
          this.totle = res.data.total
        }
      })
    },
    // 获取用户信息
    getUserInfo() {
      this.$http.getUserInfo().then((res) => {
        if (res.data != null) {
          this.$store.commit('SetUserInfo', res.data)
          this.user = res.data
        }
      })
    },
    // 万位运算符
    computeCount(value) {
      if (!value) return 0
      return value >= 10000 ? `${String(value).substring(0, 1)}万+` : value
    },
  },
  created() {
    this.getfavorList()
    this.getUserInfo()
  },
}
</script>

<style lang="less" scoped>
@import '../../../static/fonts/stylemain/style.less';
page {
  padding: 0;
  margin: 0;
  overflow: hidden;
}
/deep/.el-input__inner {
  border: 1px solid #6edbff;
  box-shadow: none;
  color: @writing1;
  height: 0.35rem;
  font-size: 0.18rem;
  width: 100%;
}
/deep/.el-input__wrapper {
  // background-color: @inputbg;
  border: 1px solid #6edbff;
  box-shadow: none;
  color: @writing1;
  height: 0.35rem;
  font-size: 0.18rem;
}
/deep/.el-input__inner {
  color: @writing1;
}
.box {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  min-height: 9.2rem;
  overflow: hidden;
  background-color: @bg3;
  .box-top {
    width: 100%;
    height: 3.8rem;
    background-image: url('../../../static/img2/gbj.png');
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    .box-top-tx {
      width: 0.9rem;
      height: 0.9rem;
    }
  }
  .box-buttom {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: -0.25rem;
    .box-tabs {
      width: 100vw;
      min-height: 5.4rem;
      background-color: @bg3;
      display: flex;
      flex-direction: column;
      align-items: center;
      overflow: hidden;
      .box-tabs-ul {
        width: 14.2rem;
        min-height: 5.4rem;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;

        .box-tabs-ulicontit {
          color: @writing1;
          font-size: 700;
          font-size: 0.24rem;
        }
        .box-tabs-li {
          width: 3.4rem;
          height: 2.5rem;
          margin-right: 0.2rem;
          margin-top: 0.2rem;
          cursor: pointer;
          .box-tabs-li-but-tit {
            width: 3.2rem;
            height: 0.41rem;
            background-color: @bg1;
            padding: 0 0.1rem 0 0.1rem;
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 0.16rem;
            color: #fff;
          }
          .box-tabs-li-img {
            width: 3.4rem;
            height: 2rem;
          }
        }
        .box-tabs-li:nth-of-type(4n + 0) {
          margin: 0.2rem 0 0 0;
        }
      }
    }
    .box-buttom-input {
      width: 100vw;
      display: flex;
      flex-direction: column;
      align-items: center;
      min-height: 5.4rem;
      background-color: @bg3;
      .box-buttom-input-li {
        width: 4.8rem;
        height: 0.35rem;
        margin-top: 0.3rem;
        display: flex;
        .box-buttom-input-left {
          width: 0.9rem;
          height: 0.35rem;
          display: flex;
          align-items: center;
          span {
            color: @writing1;
            margin-left: 0.1rem;
            font-size: 0.18rem;
          }
        }
        .box-buttom-input-rigth {
          width: 100%;
        }
        .box-buttom-input-rigthtit {
          // background-color: @inputbg;
          border: 1px solid #6edbff;
          box-shadow: none;
          color: @writing1;
          height: 0.35rem;
          border-radius: 0.04rem;
          font-size: 0.18rem;
          padding-left: 0.11rem;
          line-height: 0.3rem;
          cursor: no-drop;
        }
      }
    }
    .box-buttom-hed {
      width: 6rem;
      height: 0.36rem;
      display: flex;
      justify-content: space-between;
      background: rgba(21, 47, 71, 0.9);
      padding: 0.06rem;
      border-radius: 0.28rem;
      .box-buttom-hed-title {
        width: 1.9rem;
        height: 0.36rem;
        background-image: url('../../../static/img2/3xaunzhong.png');
        background-size: 100% 100%;
        text-align: center;
        line-height: 0.36rem;
        color: #fff;
        font-size: 0.18rem;
      }
      .box-buttom-hed-titlefalse {
        width: 1.9rem;
        height: 0.36rem;
        text-align: center;
        line-height: 0.36rem;
        color: #fff;
        cursor: pointer;
        font-size: 0.18rem;
      }
      .box-buttom-hed-titlefalse:hover {
        width: 1.9rem;
        height: 0.36rem;
        text-align: center;
        line-height: 0.36rem;
        color: rgb(92, 186, 219);
        cursor: pointer;
        font-size: 0.18rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/User/Myinfo.vue